/* Lampiero lv11 (10 Oct 2026): every price the page shows in the page language.
   en "€69", nl "€ 69", every other language "69 €" with a non-breaking space, decimal comma, ",00" never printed.
   PLN "309 zł", CZK "1 718 Kč" (local digit grouping, never "1,718"). Same rules as snippets/lv-money.liquid.
   Kaching prints its prices with the store money format ("€69", "1,008 zł", "813Kč"); lv8.js and lv.js build lines from them.
   One MutationObserver rewrites the price text inside the buy box, the sets, the sticky bars, the second-lamp view, the
   mouth tape buy box and the cart. Only tokens with €, zł, Kč (or EUR, PLN, CZK) are touched; other currencies stay as printed.
   window.lvMoney.fmt(number, 'EUR') formats one amount; lv8.js and lv.js use it for the lines they build.
   pack1 (19 Oct): on non-English pages, amounts in kr (SEK, DKK, NOK) and lei (RON) get the page language's digit grouping and a
   non-breaking space before the currency word, which stays as it was printed: sv "1 338 kr", da "1.338 kr", ro "1.224 lei"
   (Kaching printed "1,338 kr", which reads as 1.338 kr in these languages, and "372kr"). */
(function () {
  'use strict';
  var d = document, w = window, html = d.documentElement;
  var LANG = (html.lang || 'en').trim() || 'en';
  var lg = LANG.slice(0, 2).toLowerCase();
  var NB = ' ';
  var SYM = { '€': 'EUR', 'EUR': 'EUR', 'zł': 'PLN', 'PLN': 'PLN', 'Kč': 'CZK', 'CZK': 'CZK' };
  /* pack1: currency words kept as printed, regrouped only on non-English pages */
  var WORD = /^(kr\.?|lei)$/;

  function num(n, dec) {
    try {
      return new Intl.NumberFormat(LANG, { minimumFractionDigits: dec ? 2 : 0, maximumFractionDigits: dec ? 2 : 0 }).format(n);
    } catch (e) {
      var s = dec ? n.toFixed(2) : String(Math.round(n));
      return lg === 'en' ? s : s.replace('.', ',');
    }
  }
  /* one amount, in a known currency, in the page language */
  function fmt(n, cur) {
    cur = SYM[cur] || cur || 'EUR';
    if (cur !== 'EUR' && cur !== 'PLN' && cur !== 'CZK') return null;
    var neg = n < 0; n = Math.abs(n);
    var cents = Math.round(n * 100), dec = cents % 100 !== 0;
    var s = num(cents / 100, dec), out;
    if (cur === 'PLN') out = s + NB + 'zł';
    else if (cur === 'CZK') out = s + NB + 'Kč';
    else if (lg === 'en') out = '€' + s;
    else if (lg === 'nl') out = '€' + NB + s;
    else out = s + NB + '€';
    return (neg ? '-' : '') + out;
  }
  /* "1,008" / "1.008" / "1 008" are thousands, "44,89" / "44.89" are decimals */
  function parse(raw) {
    var s = String(raw).replace(/[\s  ']/g, '');
    var m = /^(.*?)[.,](\d{1,2})$/.exec(s);
    if (m) return parseFloat(m[1].replace(/[.,]/g, '') + '.' + m[2]);
    return parseFloat(s.replace(/[.,]/g, ''));
  }
  var N = '(\\d{1,3}(?:[.,\\u00a0\\u202f]\\d{3})+(?:[.,]\\d{1,2})?|\\d+(?:[.,]\\d{1,2})?)';
  /* fix 4 Nov 2026: Kaching prints Swedish and Danish amounts with a plain space between the thousands ("2 005 kr").
     N did not take a plain space, so only "005 kr" matched and became "5 kr" ("2 5 kr" on the 4-lamp tier). NS also takes
     a plain space; it is used only right before kr or lei, so "2 lamps 118 €" style text is never read as one number. */
  var NS = '(\\d{1,3}(?:[ .,\\u00a0\\u202f]\\d{3})+(?:[.,]\\d{1,2})?|\\d+(?:[.,]\\d{1,2})?)';
  var RE = new RegExp('(€|EUR)[\\s\\u00a0\\u202f]?' + N + '(?:[\\s\\u00a0\\u202f]?EUR)?' +
    '|' + NS + '[\\s\\u00a0\\u202f]?(kr\\.?(?![A-Za-zÀ-ž])|lei(?![A-Za-zÀ-ž]))' +
    '|' + N + '[\\s\\u00a0\\u202f]?(€|zł|Kč|EUR|PLN|CZK|kr\\.?(?![A-Za-zÀ-ž])|lei(?![A-Za-zÀ-ž]))(?:[\\s\\u00a0\\u202f]?(?:EUR|PLN|CZK)\\b)?', 'g');
  function fixText(t) {
    if (!t || !/\d/.test(t) || !/€|zł|Kč|EUR|PLN|CZK|kr|lei/.test(t)) return t;
    return t.replace(RE, function (all, s1, n1, nw, sw, n2, s2) {
      if (sw) { n2 = nw; s2 = sw; }
      if (s2 && WORD.test(s2)) {
        if (lg === 'en') return all;
        var v = parse(n2);
        if (isNaN(v)) return all;
        return num(v, Math.round(v * 100) % 100 !== 0) + NB + s2;
      }
      var cur = SYM[s1 || s2], n = parse(n1 || n2);
      if (!cur || isNaN(n)) return all;
      var o = fmt(n, cur);
      return o || all;
    });
  }

  var ROOTS = 'kaching-bundles-block,[data-lv-sticky],[data-lv6-sets],[data-lvf],[data-nt-bb],.nt-sticky,#main-cart-items,#main-cart-footer,cart-notification,.lv11-price';
  function pass(root) {
    var walker = d.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n, todo = [];
    while ((n = walker.nextNode())) {
      var p = n.parentNode;
      if (!p || p.nodeName === 'SCRIPT' || p.nodeName === 'STYLE') continue;
      var v = n.nodeValue, o = fixText(v);
      if (o !== v) todo.push([n, o]);
    }
    todo.forEach(function (x) { x[0].nodeValue = x[1]; });
    /* the second-lamp view copies prices from data attributes */
    if (root.querySelectorAll) [].forEach.call(root.querySelectorAll('[data-now]'), function (el) {
      var v = el.getAttribute('data-now'), o = fixText(v); if (o !== v) el.setAttribute('data-now', o);
    });
  }
  function run() {
    timer = 0;
    try { [].forEach.call(d.querySelectorAll(ROOTS), pass); } catch (e) { if (w.console) console.warn('lv-money', e); }
    if (mo) mo.takeRecords();
  }

  w.lvMoney = { fmt: fmt, fix: fixText, parse: parse, run: function () { run(); } };
  /* English pages already print "€69": nothing to rewrite for EUR; PLN and CZK still need the grouping fix */
  var timer = 0, mo = null;
  if (!('MutationObserver' in w)) return;
  mo = new MutationObserver(function () { if (!timer) timer = setTimeout(run, 30); });
  function start() {
    mo.observe(d.body, { childList: true, subtree: true, characterData: true });
    run();
    [500, 1500, 4000].forEach(function (t) { setTimeout(function () { if (!timer) run(); }, t); });
  }
  if (d.body) start(); else d.addEventListener('DOMContentLoaded', start);
})();
